<template>
  <div id="printMe" style="position: relative">
    <img
      src="@/assets/card.png"
      style="width: 102.9mm; height: 70.4mm; position: relative"
    />
    <img
      v-if="data.prefecture_logo"
      :src="'https://api.sigfrotagov.com.br/uploads/' + data.prefecture_logo"
      style="
        width: 25mm;
        height: 25mm;
        position: absolute;
        top: 110px;
        left: 275px;
      "
    />
    <div
      style="
        width: 40mm;
        height: 16mm;
        position: relative;
        bottom: 43mm;
        left: 20px;
      "
    >
      <p class="card-subtitle">{{ data.prefecture_social_name }}</p>
      <p class="card-subtitle">{{ data.sec_name }}</p>
      <p class="card-subtitle">Veículo: {{ data.model_desc }}</p>
      <p class="card-subtitle">Placa: {{ data.vehicle_board }}</p>
      <p class="card-subtitle">Senha: {{ data.vehicle_password }}</p>
      <!-- <div style="text-align:right;margin-top: 10px;font-size:0.6rem">
          <p style="margin:0">CONTATOS PARA SUPORTE</p>
          <p style="margin:0">WhatsApp (83) 9 9891-1172</p>
          <p style="margin:0">WhatsApp (83) 9 9627-6932</p>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style>
</style>